module.exports = __webpack_public_path__ + "img/lucky-title-bg.baefaf3a.png";